<template>
  <v-dialog v-model="modal" persistent width="1000px">
    <v-card>
      <v-card-title> Changement d'adresse courriel</v-card-title>
      <v-card-text>
        <v-form ref="form" :readonly="working" @submit.stop.prevent>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <p class="accent-block">
                  Saisissez votre nouvelle adresse courriel. Un lien vous sera envoyé, vous aurez 20 minutes pour l'activer.
                </p>
              </v-col>
              <v-col cols="12">
                  <v-text-field
                      dense
                      label="Courriel"
                      v-model="email"
                      filled
                      :rules="[requiredRule(), serverRule('email')]"
                      persistent-hint
                      hint="Cette adresse sera utilisée pour valider votre compte, et vous permettra de vous identifier."
                      data-testid="mail"
                  />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-changer-mail" color="primary" @click="valider" :loading="working"> Valider </v-btn>
        <v-btn data-testid="annuler-changer-mail" @click="ferme" :disabled="working"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import makeRules from "@/mixins/makeRules";
import { VuexSnackbar } from "@/mixins/makeVuexSnackbar";
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import {principalService} from "@/services";

export default {
  mixins: [
    VuexSnackbar,
    makeRules({ inject: false }),
    makeRemoteWorker({ provide: false })
  ],


  data() {
    return {
      working: false,
      modal: false,
      email: null,
    };
  },

  methods: {
    ferme() {
      this.modal = false;
    },

  ouvre(email, callback) {
      this.email = email;
      this.callback = callback;
      this.modal = true;
      this.$nextTick(() => {
        this.$refs.form.resetValidation();
      });
    },

    valider() {
      const callback = this.callback;
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return principalService.changementAdresseMail(this.email);
        },
        callback(response) {
          this.modal = false;
          callback(response);
        },
        errorText: "Le changement n'a pas été effectué.",
        successText: "Un courriel a été envoyé à votre adresse.",
      });
    },
  },
};
</script>
